export const isNumber = (value) => {
    return typeof value === 'number';
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/typeGuards/index.js